import React from 'react';
import styled from 'styled-components';
import CardLabel from './CardLabel';
import { Wallet } from '../../../../../../providers/DonorProvider/interfaces';
import colors from '../../../../../theme/colors';
import { Text } from '../../../common/Text/Text';

interface CardInfoProps {
    id?: string;
    card: Omit<Wallet, 'id' | 'isPreferred' | 'paymentInstrumentUuid'>;
    className?: string;
}

const StyledDiv = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: end;
    margin-right: 26px;
    text-align: right;
    .card-label {
        margin-right: 8px;
    }
`;

const StyledDivNumber = styled.div`
    display: flex;
    align-items: center;
    .dots {
        display: flex;
        margin-top: 3px;
        align-items: center;
        .dot {
            background-color: ${colors['primaryPrimaryContent']};
            width: 4px;
            height: 4px;
            margin-right: 2px;
            border-radius: 50px;
        }
    }
    .last-digits {
        margin-top: 3px;
        margin-left: 3px;
    }
`;

export const CardNumbers: React.FC<CardInfoProps> = ({ id, card, className }) => {
    const lastFourDigits = card.number.replace(/X/g, '');
    return (
        <StyledDivNumber id={id} className={className}>
            <div id={id ? `${id}-masked-digits` : undefined} className={'dots'}>
                <div id={id ? `${id}-dot-1` : undefined} className={'dot'} />
                <div id={id ? `${id}-dot-2` : undefined} className={'dot'} />
                <div id={id ? `${id}-dot-3` : undefined} className={'dot'} />
                <div id={id ? `${id}-dot-4` : undefined} className={'dot'} />
            </div>
            <Text
                id={id ? `${id}-last-four-digits` : undefined}
                className={'last-digits'}
            >
                {lastFourDigits}
            </Text>
        </StyledDivNumber>
    );
};

const CardInfo: React.FC<CardInfoProps> = ({ id, card, className }) => {
    return (
        <StyledDiv id={id} className={className}>
            <CardLabel
                id={id ? `${id}-brand` : undefined}
                cardType={card.type}
                className={'card-label'}
            />{' '}
            <CardNumbers id={id ? `${id}-number` : undefined} card={card} />
        </StyledDiv>
    );
};

export default CardInfo;
